import BookIndex from "components/shared/book/list";
import { catalogEntityOptionFlags, entityTypes } from "helpers/enums";
import { paths } from "helpers/paths";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import React from "react";
import { Link } from "react-router-dom";

class OrganizationCatalogs extends BookIndex {
    renderTableRow = (item, index) => {
        const { entityOptionId, displayName, catalogPropertyName, entityType, intFlags } = item;
        return (
            <tr
                key={entityOptionId}
                onClick={() => this.props.history.push(paths.organizationCatalogsShow(entityOptionId))}
                className={this.context.prevItemId === entityOptionId ? "book-tr__prev-row" : ""}
            >
                <td>{index + 1}</td>
                <td>{entityOptionId}</td>
                <td>
                    <Link to={paths.organizationCatalogsShow(entityOptionId)}>{displayName}</Link>
                </td>
                <td>{catalogPropertyName}</td>
                <td>{enumLabel(entityTypes, entityType)}</td>
                <td>{this.renderFlagVals(intFlags)}</td>
            </tr>
        );
    };

    renderFlagVals = (intFlags) => {
        return catalogEntityOptionFlags.map((option) => {
            if (option.intValue === 0) {
                return null;
            }
            if ((intFlags & option.intValue) === option.intValue) {
                return option.label;
            }
            return null;
        });
    };

    thead = () => {
        return (
            <thead className="thead-light">
                <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Название</th>
                    <th>Идентификатор</th>
                    <th>Тип сущности</th>
                    <th>Настройки</th>
                </tr>
            </thead>
        );
    };
}

export default tableContainer(OrganizationCatalogs, "organizationcatalogs");
